import { render } from "./DeletePaymentMethodModal.vue?vue&type=template&id=2e8d0d73"
import script from "./DeletePaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./DeletePaymentMethodModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__